<template>
  <div>
    <Form ref="searchForm" inline class="search-form">
      <Form-item>
        <Input
          style="width:200px"
          placeholder="请输入角色关键字"
          v-model="searchCondition.keywords"
          clearable
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button style="margin-right:20px;" type="primary" :to="{name: 'RoleEdit'}">新增角色</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        data-url="/api/role"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="admin_uid"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" :to="{name: 'RoleEdit',query:{id:row.role_id}}">编辑</Button>-
          <Button type="text" size="small" @click="del('one',row.role_id)">删除</Button>
        </template>
        <template slot="footer-left">
          <div class="button-group">
            <Button :disabled="selectList.length == 0" @click="del('all','')">删除</Button>
          </div>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "SettingRole",
  data() {
    return {
      column: [
        {
          title: "角色",
          key: "role_name",
          minWidth: 180,
          align: "center"
        },
        {
          title: "描述",
          key: "description",
          minWidth: 180,
          align: "center"
        },
        {
          title: "更新时间",
          key: "updated_at",
          minWidth: 160,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          minWidth: 120,
          align: "center",
          fixed: "right"
        }
      ],
      selectList: [],
      searchCondition: {
        keywords: ""
      }
    };
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(i => {
        if (i.updated_at && i.updated_at != "0")
          i.updated_at = this.$pub.timestampToTime(i.updated_at);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.keywords = "";
      }
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(val) {
      this.selectList = val;
    },
    del(_type, _id) {
      let ids = "";
      if (_type == "one") {
        ids = _id;
      } else {
        if (this.selectList.length == 0) {
          this.$Message.error("请至少选择一个账号");
          return;
        }
        let arr = [];
        this.selectList.forEach(i => {
          arr.push(i.role_id);
        });
        ids = arr.join(",");
      }
      this.$Modal.confirm({
        title: "删除",
        content: "确定要删除该账号吗？",
        onOk: async () => {
          await this.delete(ids);
        },
        onCancel: () => {}
      });
    },
    async delete(_ids) {
      await this.$http.delete(`/api/role/${_ids}`);
      this.$Message.deleteSuccess();
      this.search(1);
      this.selectList = [];
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
